import { DealStatus } from '../Deal';

export interface CurrentUser {
	userId: number;
	userGuid: string;

	personId: number;

	username: string;

	role: number;

	prefix: string | null;
	firstName: string;
	lastName: string;
	suffix: string | null;

	isEmployeeUser: boolean;
	isCompanyUser: boolean;
	isBankUser: boolean;
	isTeamMemberUser: boolean;
	isTransactionManagerUser: boolean;
	isLenderRelationsManagerUser: boolean;
	defaultTimezone: string;

	controlledObjects: UserControlledObject[];
}

export function CurrentUserHasPermission(currentUser: CurrentUser | null, permission: ControlledObjectType): boolean {
	if (!currentUser) return false;
	if (!currentUser.isEmployeeUser) return false;

	return currentUser.controlledObjects.some(controlledObject => controlledObject.type === permission);
}

export function ShowSendPreMarketDealEmails(
	currentUser: CurrentUser | null,
	dealStatus: DealStatus | undefined
): boolean {
	if (!currentUser) return false;
	if (!currentUser.isEmployeeUser) return false;
	if (dealStatus === undefined) return false;
	if (dealStatus !== 'Accepted') return false;

	return CurrentUserHasPermission(currentUser, 'SendPreMarketDealEmails');
}

export interface UserControlledObject {
	guid: string;
	type: ControlledObjectType;
	hasAccess: boolean;
}

export type ControlledObjectType = keyof typeof ControlledObjectTypeMap;
export const ControlledObjectTypeMap = {
	ManageUserAccount: 'Manage User Accounts',
	SingleSignOnTemplates: 'SSO Templates',
	ResetCovenants: 'Reset Covenants',
	MilestoneDefaults: 'Milestone Defaults',
	ResetCompanyFinancials: 'Reset Company Financials',
	LoanPurposeFacilities: 'Loan Purpose Facilities',
	EditInvoices: 'Edit Invoices',
	NaicsCodes: 'NAICS Codes',
	LoanApplicationForm: 'Loan Application Forms',
	TaskChecklistInformation: 'Task Checklist Document Info',
	ApplicationSettings: 'Application Settings',
	ManageIndustries: 'Manage Industries',
	ComplimentaryAnalysisOutputFormulas: 'Loan Assessment Output Formulas',
	DeleteLoanAssessment: 'Delete Loan Assessment, Copy Loan Application',
	AccessDealPartners: 'Access Deal Partners',
	AccessLoanAssessments: 'Access Loan Assessments',
	AccessDataRooms: 'Access Data Rooms',
	ManageLenderProfiles: 'Access Lender Profiles',
	AccessBorrowerProfiles: 'Access Borrower Profiles',
	AccessSubscriptions: 'Access Subscriptions, Products & Invoices',
	MatchingConfiguration: 'Matching Configuration',
	UpdateHubSpotId: 'Update HubSpot Id',
	ApplicationErrors: 'Manage Application Errors',
	ManageExecutiveSummary: 'Manage Executive Summary',
	TermSheetFee: 'Term Sheet Fees',
	ManageViewJobs: 'Manage/View Jobs',
	FinancialCovenantType: 'Financial Covenant Types',
	DoNotPostToHubspot: 'Do Not Post Deal to Hubspot',
	BankAccountManagement: 'Bank Account Management',
	DataSubscriptions: 'Data Subscriptions',
	EmployeeReports: 'Employee Reports',
	ManageProducts: 'Manage Products',
	ChatRules: 'Chat Rules',
	EditClosedFundedDeals: 'Edit Closed Funded Deals',
	SendPreMarketDealEmails: 'Send Pre-Market Deal Emails',
};
